module.exports = __webpack_public_path__ + "img/Engie E&C_80X30.a9599236.png";